import TABLET_IMG from '../../../resources/images/privateAreaNavigationPage/tablet.jpg'

export { TABLET_IMG }

export const privateAreaGuideArray = [
  {
    title: 'geoVisor',
    description: 'geoVisor',
    url: 'https://geonednew.adn.naturgy.com/#/Login',
    manualUrl: 'https://www.nedgia.es/wp-content/uploads/2024/03/Guia-Basica-Geovisor.pdf', // URL para el botón "MANUAL"
  },
  {
    title: 'HSE',
    description: 'HSE',
    url: 'https://www.hse.nedgia.es',
    manualUrl: 'https://www.nedgia.es/wp-content/uploads/2024/03/Manual-Hse.pdf', // URL para el botón "MANUAL"
  },
  {
    title: 'Acces',
    description: 'Acces',
    url: 'https://www.nedgia.es/colaboradores/formulario-solicitud-acceso-a-sistemas-nedgia/',
  },
]